// extracted by mini-css-extract-plugin
export default {"Container":"LevelSelector_Container__FXy9V","InputsGroup":"LevelSelector_InputsGroup__-zSJj","Marker":"LevelSelector_Marker__hO7Z8","IconButton":"LevelSelector_IconButton__anUQB"};